import { combineReducers } from 'redux';
import { ZwalletPaymentReducer } from './Payment/reducer';
import { ZwalletTransferReducer } from './Transfer/reducer';
import { ZwalletOperationsReducer } from './Operations/reducers';
import { ZwalletDashboardReducer } from './Dashboard/reducers';

const zwalletReducers = combineReducers({
  payment: ZwalletPaymentReducer,
  transfer: ZwalletTransferReducer,
  extract: ZwalletOperationsReducer,
  dashboard: ZwalletDashboardReducer
});

export default zwalletReducers;


// WEBPACK FOOTER //
// ./src/ZWallet/reducers.js